import { IGetState, TCardId } from '../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../types/actions';
import { getCardRelatedCardsActive } from '../../../../store/model/selectors/getCardRelatedCardsActive';
import { TStatus } from '../../../../types/model';
import { cardUpdateRelatedCards } from './cardUpdateRelatedCards';
import { IRestRelatedCard } from '../../../../types/rest/IRestRelatedCard';

export const deleteRelation = (
    cardId: TCardId,
    relatedCard: IRestRelatedCard
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const relatedCards = getCardRelatedCardsActive(getState(), cardId).map((mapRelatedCard) => {
            const newRelatedCard = { ...mapRelatedCard };
            if (relatedCard.cardId === newRelatedCard.cardId) {
                newRelatedCard.status = TStatus.STATUS_DELETED;
            }
            return newRelatedCard;
        });
        return dispatch(cardUpdateRelatedCards(cardId, relatedCards))
    };
    return action;
};
